<template>
  <base-dialog :show-dialog="showDialog">
    <template v-slot:body>
      <v-card class="pt-4 pb-2">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                :placeholder="
                  $t('placeholders.digite', {
                    campo: $t('labels.departamento'),
                  })
                "
                :label="$t('labels.departamento')"
                class="text caption ml-1"
                @input="searchDepartament($event)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-data-table
              dense
              dark
              hide-default-footer
              :headers="selectedHeaderOptions"
              :items="departamentList"
              :loading="loadingItems"
              :items-per-page="10"
            >
              <template v-slot:item.pin="{ item }">
                <v-btn-toggle tile>
                  <v-btn fab color="warning" x-small @click="pinObject(item)">
                    <v-icon color="white">mdi-pin-outline</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" @click="$emit('close')">
            <span class="white--text">
              {{ $t('labels.fechar') }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog.vue'
// import MegabitTable from "@/components/shared/table/MegabitTable";
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { mapState, mapActions } from 'vuex'
import { translateList } from '@/utils/utils'

export default {
  mixins: [tableMixin],
  data: () => {
    return {
      timer: null,
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseDialog,
    // MegabitTable
  },
  computed: {
    ...mapState('departamentModule', [
      'loadingItems',
      'pagination',
      'departamentList',
    ]),
    selectedHeaderOptions() {
      const header = [
        {
          label: 'codigo',
          text: 'CODIGO',
          value: 'CODIGO',
        },
        {
          label: 'descricao',
          text: 'DESCRICAO',
          value: 'DESCRICAO',
        },
        {
          label: 'classificacao',
          text: 'CLASSIFICACAO',
          value: 'CLASSIFICACAO',
        },
        {
          label: 'acoes',
          text: 'Ações',
          value: 'pin',
          align: 'right',
        },
      ]
      return translateList(header)
    },
  },
  methods: {
    pinObject(item) {
      this.$emit('object-pin', item)
    },
    ...mapActions('departamentModule', [
      'getDepartaments',
      'getDepartament',
      'setSelectedItem',
      'deleteDepartament',
    ]),
    searchDepartament($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event.target.value ?? null

					if (!param || param.trim().length <= 0) return

					let payload = { page: 1 }

					if (param.lastIndexOf('-') == -1) {
						payload.hibrido = param
					} else {
						param = param
							.trim()
							.split('-')[0]
							.trim()

						payload.codigo = parseInt(param)
					}
					this.getDados(payload)
				}, 600)
			} catch (error) {
				this.$toasted.error(error)
			}
		},
		async getDados(object) {
			try {
				await this.getDepartaments(object)
			} catch (error) {
				this.$toasted.error(error)
			}
		},
	},
}
</script>

<style></style>
